import Vue from 'vue';
import Router from 'vue-router';
import Static from '@/components/Static';
import About from '@/components/About';
import Login from '@/components/Login';
import Index from '@/components/Index';
import Map from '@/components/Map';
import Customers from '@/components/Customers';
import Members from '@/components/Members';
import Compare from '@/components/Compare';
import CreateDate from '@/components/CreateDate';
import Update from '@/components/Update';
import Softium0 from '@/components/Softium0';
import Softium1 from '@/components/Softium1';
import Softium2 from '@/components/Softium2';
import Softium3 from '@/components/Softium3';
import Softium4 from '@/components/Softium4';
import DemoIndex from '@/components/DemoIndex';
import DemoMap from '@/components/DemoMap';
import DemoSet from '@/components/DemoSet';
import DemoUpload from '@/components/DemoUpload';
import DemoLogin from '@/components/DemoLogin';
import DemoShowAll from '@/components/DemoShowAll';
import MineDemo from '@/components/MineDemo';
import DemoZr from '@/components/DemoZr';
import Competiton from '@/components/Competiton';
import Yonghui from '@/components/Yonghui';

Vue.use(Router);

export default new Router({
  mode: 'history', // 路由history模式。开启打包之后一篇空白
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: '/',
      name: 'Static',
      component: Static
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
      redirect: {
        name: 'Map'
      },
      children: [
        {
          path: '/map',
          name: 'Map',
          component: Map
        },
        {
          path: '/customers',
          name: 'Customers',
          component: Customers
        },
        {
          path: '/members',
          name: 'Members',
          component: Members
        },
        {
          path: '/compare',
          name: 'Compare',
          component: Compare
        }
      ]
    },
    {
      path: '/option',
      name: 'CreateDate',
      component: CreateDate
    },
    {
      path: '/update',
      name: 'Update',
      component: Update
    },
    {
      path: '/softium0',
      name: 'Softium0',
      component: Softium0
    },
    {
      path: '/softium1',
      name: 'Softium1',
      component: Softium1
    },
    {
      path: '/customer',
      name: 'Softium2',
      component: Softium2
    },
    {
      path: '/softium3',
      name: 'Softium3',
      component: Softium3
    },
    {
      path: '/softium4',
      name: 'Softium4',
      component: Softium4
    },
    {
      path: '/demo-mine',
      name: 'MineDemo',
      component: MineDemo
    },
    {
      path: '/demo-zr',
      name: 'DemoZr',
      component: DemoZr
    },
    {
      path: '/field',
      name: 'DemoLogin',
      component: DemoLogin
    },
    {
      path: '/demo',
      name: 'DemoIndex',
      component: DemoIndex,
      redirect: {
        name: 'Competiton' //默认打开的地址
      },
      children: [
        {
          path: '/field-map',
          name: 'DemoMap',
          component: DemoMap
        },
        {
          path: '/field-set',
          name: 'DemoSet',
          component: DemoSet
        },
        {
          path: '/field-upload',
          name: 'DemoUpload',
          component: DemoUpload
        },
        {
          path: '/field-show',
          name: 'DemoShowAll',
          component: DemoShowAll
        },
        {
          path: '/competion',
          name: 'Competiton',
          component: Competiton
        },
        {
          path: '/yonghui-test',
          name: 'Yonghui',
          component: Yonghui
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js